/**
 * [PRD-2043] Minimal client-side CSV export for the Charge Report tables.
 * Builds an RFC-4180-ish CSV (quotes fields containing comma/quote/newline)
 * and triggers a browser download — no dependency, no server round-trip.
 */
type Cell = string | number | null | undefined;

const escapeCell = (value: Cell): string => {
  const s = value === null || value === undefined ? "" : String(value);
  return /[",\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
};

export function downloadCsv(filename: string, headers: string[], rows: Cell[][]): void {
  const lines = [headers.map(escapeCell).join(","), ...rows.map((r) => r.map(escapeCell).join(","))];
  const blob = new Blob([lines.join("\n")], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}
